export interface TranslationMap {
    [key: string]: string;
}

export interface Resources {
    [lang: string]: {
        translation: TranslationMap;
    };
    pt: {
        translation: TranslationMap;
    };
    en: {
        translation: TranslationMap;
    };
}

export interface TutorialData {
    key: string;
    mobiTag: string;
    bgColor: string;
    url?: string;
}

export interface TipData {
    key: string;
    imageRef: string;
}

export const tutorialStructure: TutorialData[] = [
    { key: 'stack', mobiTag: 'Level 1', bgColor: '#54d643ff', url: '/img/imgs-card/newbie.png' },
    { key: 'sofa', mobiTag: 'Level 1', bgColor: '#54d643ff', url: '/img/imgs-card/lodge.png' },
    { key: 'basico', mobiTag: 'Level 2', bgColor: '#f1ee07ff', url: '/img/imgs-card/wall.png' },
    { key: 'mesa', mobiTag: 'Level 3', bgColor: '#ee8104ff', url: '/img/imgs-card/curtains.png' },
];

export const tipData: TipData[] = [
    { key: 'rollers', imageRef: '/img/15.gif' },
    { key: 'pouf', imageRef: '/img/1.gif' },
    { key: 'merge', imageRef: '/img/2.gif' },
    { key: 'rugs', imageRef: '/img/13.gif' },
    { key: 'rugsWithCds', imageRef: '/img/9.gif' },
    { key: 'rusticCorners', imageRef: '/img/5.gif' },
    { key: 'partition', imageRef: '/img/3.gif' },
    { key: 'chairOnSofa', imageRef: '/img/8.gif' },
    { key: 'floorOnDoors', imageRef: '/img/10.gif' },
    { key: 'pureShelves', imageRef: '/img/11.gif' },
    { key: 'partitionsOnDoors', imageRef: '/img/14.gif' },
];

export const resources: Resources = {
    pt: {
        translation: {
            // Navegação
            "nav.home": "Início",
            "nav.stackmode": "Stackmode",
            "nav.discord": "Discord",
            "nav.habbold": "Habbold",
            
            // Títulos e cabeçalhos
            "app.section.tutorials": "TUTORIAIS EM DESTAQUE",
            "app.section.tips": "DICAS ESSENCIAIS",
            
            // Botões
            "button.start": "COMEÇAR AGORA",
            "button.view": "Ver tutorial",
            "button.close": "Fechar",
            
            // Rodapé
            "footer.text": "© 2025 Stacking. Não afiliado ao Habbo Hotel:Origins.",
            
            // Dicas
            "tips.rollers": "É extremamente importante o uso de rollers e CD's!",
            "tips.pouf": "Empilhamento de pufes",
            "tips.merge": "E você também pode mesclar!",
            "tips.rugs": "Empilhamento de Tapetinhos.",
            "tips.rugsWithCds": "Empilhamento de Tapetinhos com CDs",
            "tips.rusticCorners": "Empilhamento de cantos Rústicos",
            "tips.partition": "Empilhamento de Divisória",
            "tips.chairOnSofa": "Empilhamento de Cadeira em sofá",
            "tips.floorOnDoors": "Empilhamento de Pisos em portas",
            "tips.pureShelves": "Empilhamento de Prateleiras puras",
            "tips.partitionsOnDoors": "Empilhamento de Divisórias em portas",
            
            // Tutoriais - Títulos e descrições
            "tutorials.basico.title": "Stacking - Mix Area/Cabin",
            "tutorials.basico.description": "Um tutorial médio, com alternância entre :stackmode 0 e 1",
            "tutorials.mesa.title": "Stacking - Cortinas",
            "tutorials.mesa.description": "Um tutorial um pouco mais avançado e mais detalhado utilizando Area + Cabin + Mobis HC.",
            "tutorials.sofa.title": "Variaçoes Rústicas",
            "tutorials.sofa.description": "Um simples guia de como as variaçoes de mobis rústicos fazem combinação.",
            "tutorials.stack.title": "Ainda não sabe como empilhar?",
            "tutorials.stack.description": "Aqui é a base toda que você precisa aprender para construir.",
            
            
            // Conteúdo dos tutoriais (HTML)
            "tutorials.mesa.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube.com/embed/5taDShK13Vo?autoplay=1&rel=0&controls=1" 
                frameborder="0" 
                allowfullscreen>
                </iframe>
            </div>
            <p>Você irá precisar de:</p>
            <ul>
                <li><img src="/img/areacorner.png" alt="Canto Area" /> 6x Cantos Area</li>
                <li><img src="/img/cabindivi.png" alt="Divisória Cabin" /> 3x Divisória Cabin</li>
                <li><img src="/img/plinth.png" alt="Canto Cabin" /> 6x Canto Cabin </li>
                <li><img src="/img/curtain.png" alt="Cortinas HC" /> 2x Cortinas HC</li>
            </ul>
`,
            "tutorials.sofa.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube-nocookie.com/embed/x7AhfWpzfTE?autoplay=1&rel=0&controls=1" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
                </iframe>
            </div>
            <p>Um simples guia de como as variações de mobis rústicos fazem combinação.</p>
`,
            "tutorials.basico.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube.com/embed/euChU9b-fPk?autoplay=1&rel=0&controls=1" 
                frameborder="0" 
                allowfullscreen>
                </iframe>
            </div>
            <p>Você irá precisar de:</p>
            <ul>
                <li><img src="/img/areacorner.png" alt="Canto Area" /> 4x Cantos Area</li>
                <li><img src="/img/cabindivi.png" alt="Divisória Cabin" /> 3x Divisória Cabin</li>
                <li><img src="/img/plinth.png" alt="Canto Cabin" /> 2x Canto Cabin</li>
                <li><img src="/img/areadivi.png" alt="Biombo Area" /> 6x Biombo Area</li>
            </ul>
`,
            "tutorials.stack.content": `
            <div class="stack-explain">
                <p>Aqui você irá aprender os dois modos de :stackmode para fazer as suas construçoes.</p>
            <h1>:stackmode 1</h1>
            <p>Aqui vemos o :stackmode 1 ativado, ele empilha os mobis "infinitamente".</p>
                <img src="/img/stackmode1.gif" />
            </div>
            <div class="stack-explain">
            <h1>:stackmode 0</h1>
            <p>Aqui vemos o :stackmode 0 ativado, ele empilha os mobis até a 2° Camada.</p>
                <img src="/img/stackmode0.gif" />
            </div>
`}
    },
    en: {
        translation: {
            // Navigation
            "nav.home": "Home",
            "nav.stackmode": "Stackmode",
            "nav.discord": "Discord",
            "nav.habbold": "Habbold",
            
            // Headers and titles
            "app.section.tutorials": "FEATURED TUTORIALS",
            "app.section.tips": "ESSENTIAL TIPS",
            
            // Buttons
            "button.start": "START NOW",
            "button.view": "View Tutorial",
            "button.close": "Close",
            
            // Footer
            "footer.text": "© 2025 Stacking. Not affiliated with Habbo Hotel:Origins.",
            
            // Tips
            "tips.rollers": "Using rollers and CDs is extremely important!",
            "tips.pouf": "Pod stacking.",
            "tips.merge": "And you can also merge!",
            "tips.rugs": "Doormats stacking.",
            "tips.rugsWithCds": "Doormats stack with CDs.",
            "tips.rusticCorners": "Lodge/Cabin/Amberwood Plinth stacking.",
            "tips.partition": "Lodge/Cabin/Amberwood Divider stacking.",
            "tips.chairOnSofa": "Chair on Sofa stacking.",
            "tips.floorOnDoors": "Stacking tiles inside doors.",
            "tips.pureShelves": "Pure Shelves stacking.",
            "tips.partitionsOnDoors": "Stacking dividers inside doors.",
            
            // Tutorials - Titles and descriptions
            "tutorials.basico.title": "Stacking - Mix Area/Cabin",
            "tutorials.basico.description": "A medium tutorial, switching between :stackmode 0 and 1",
            "tutorials.mesa.title": "Stacking - Curtains",
            "tutorials.mesa.description": "A slightly more advanced and detailed tutorial using Area + Cabin + HC Furni.",
            "tutorials.sofa.title": "Lodge Variations",
            "tutorials.sofa.description": "A simple guide on how variations of rustic furni combine.",
            "tutorials.stack.title": "Still don’t know how to stack?",
            "tutorials.stack.description": "Here is the entire foundation you need to learn in order to build.",


            
            // Tutorial content (HTML)
            "tutorials.mesa.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube.com/embed/5taDShK13Vo?autoplay=1&rel=0&controls=0" 
                frameborder="0" 
                allowfullscreen>
                </iframe>
            </div>
            <p>You will need:</p>
            <ul>
                <li><img src="/img/areacorner.png" alt="Area corner" /> 6x Area corner</li>
                <li><img src="/img/cabindivi.png" alt="Cabin divider" /> 3x Cabin divider</li>
                <li><img src="/img/plinth.png" alt="Cabin Plinth" /> 6x Cabin Plinth</li>
                <li><img src="/img/curtain.png" alt="Curtains" /> 2x Curtains</li>
            </ul>
`,
            "tutorials.sofa.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube-nocookie.com/embed/x7AhfWpzfTE?autoplay=1&rel=0&controls=1" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
                </iframe>
            </div>
            <p>A simple guide on how lodge furniture variations combine.</p>
`,
            "tutorials.basico.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube.com/embed/euChU9b-fPk?autoplay=1&rel=0&controls=0" 
                frameborder="0" 
                allowfullscreen>
                </iframe>
            </div>
            <p>You will need:</p>
            <ul>
                <li><img src="/img/areacorner.png" alt="Area corner" /> 4x Area corner</li>
                <li><img src="/img/cabindivi.png" alt="Cabin divider" /> 3x Cabin divider</li>
                <li><img src="/img/plinth.png" alt="Cabin Plinth" /> 2x Cabin Plinth</li>
                <li><img src="/img/areadivi.png" alt="Area Divider" /> 6x Area Divider</li>
            </ul>
`
,
            "tutorials.newbie.content": `
            <div class="video-container">
                <iframe 
                width="100%" 
                height="400" 
                src="https://www.youtube.com/embed/euChU9b-fPk?autoplay=1&rel=0&controls=0" 
                frameborder="0" 
                allowfullscreen>
                </iframe>
            </div>
            <p>You will need:</p>
            <ul>
                <li><img src="/img/areacorner.png" alt="Area corner" /> 4x Area corner</li>
                <li><img src="/img/cabindivi.png" alt="Cabin divider" /> 3x Cabin divider</li>
                <li><img src="/img/plinth.png" alt="Cabin Plinth" /> 2x Cabin Plinth</li>
                <li><img src="/img/areadivi.png" alt="Area Divider" /> 6x Area Divider</li>
            </ul>
`,
            "tutorials.stack.content": `
            <div class="stack-explain">
    <p>Here you will learn the two :stackmode modes. This will help on your buildings.</p>
    <h1>:stackmode 1</h1>
    <p>Here :stackmode 1 activated; it stacks furni “infinitely.”</p>
    <img src="/img/stackmode1.gif" />

    <div class="stack-explain">
        <h1>:stackmode 0</h1>
        <p>Here :stackmode 0 activated; it stacks furni up to the 2nd layer.</p>
        <img src="/img/stackmode0.gif" />
    </div>

            </div>
`
        }
    }
};

export const initialLang = 'pt';

// Função de tradução manual
export const t = (key: string, lang: string): string => {
    if (resources[lang]?.translation?.[key]) {
        return resources[lang].translation[key];
    }
    if (resources.pt?.translation?.[key]) {
        return resources.pt.translation[key];
    }
    return key;
};
